/**
 * Created by Pavel Kozhin on 29.05.15.
 */

/* global define:false */
define(['require',
    'jquery',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object',
    'library/fcse-util/url',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'util/router',
    'handlebars'
], function(require, $, Widget, Object, Url, OptionsMixin, EventDispatcher, Routing, Handlebars) {
    'use strict';
    /**
     * Search widget
     *
     * @name SearchWidget
     * @constructor
     */
    var SearchWidget = function(element, options, scope) {

        var url = new Url();

        this._locale = url.getLocale();
        this._currentQuery = null;
        this._lastResponse = null;
        this._lastDestinationsResponse = null;
        this._isHotelDataLoaded = false;
        this._isDestinationDataLoaded = false;

        var defaultOptions = {
            minLength: 3,
            limit: 100,
            delay: 225,
            hotelsRoute: 'allt_frontend.ssg.search_hotels',
            destinationsRoute: 'allt_frontend.ssg.search_destinations',
            routeParamName: 'term',
            routeTypeName: 'type',
            routeType: 'hotel_only_suggestion,hotel_suggestion',
            responseDataField: 'items',
            dataField: 'name',
            useHint: false,
            useHighlight: false,
            useHeader: false,
            useRootScopeParams: [],
            identifyField: 'id',
            hotelResponseType: 'hotel',
            destinationResponseType: 'destination',
            // scoped means we update widget value on change
            scoped: false,
            emptyResultText: 'No hotels found',
            bookingType: scope.getParam('bookingType'),
            rootScope: null,
            isTyping: false
        };

        options = $.extend({}, defaultOptions, options || {});

        // Widget Apply
        Widget.apply(this, [element, options]);

        this._init();
    };

    SearchWidget.prototype = $.extend(Object.create(Widget.prototype), {

        /**
         * @private
         */
        _locale: null,

        /**
         * typeAhead JQuery element
         * @private
         */
        _typeAhead: null,

        /**
         * Selectors for element
         * @private
         */
        _selectors: {
            input: '[data-fcse-role="ajax-type-ahead"]'
        },

        /**
         * This is the hook for all initialization logic
         * @protected
         */
        _init: function () {
            this._hotelsRoute = this.option('hotelsRoute');
            this._destinationsRoute = this.option('destinationsRoute');
            this._redirectTarget = this.element.data('redirect-target');

            $('[data-fcse-role="ssg-submit"]', this.element).click($.proxy(this._onSubmit, this, true));

            require(['bloodhound', 'typeahead'] , $.proxy(this._initTypeAhead, this));

            $.cookie('hotelSearch-searchmask-search-widget', '', {
                path    : '/',
                secure  : false
            });
            $.cookie('hotelSearch-search-widget', '', {
                path    : '/',
                secure  : false
            });
        },

        _oncompleted: function(){
            this.isTyping = false;
        },

        /**
         * Initializes typeahead
         * @param Bloodhound
         * @private
         */
        _initTypeAhead: function (Bloodhound) {
            this._typeAhead = $(this._selectors.input, this.element);
            if (this._typeAhead) {
                this._typeAhead.bind('typeahead:select', $.proxy(this._onSuggestionSelect, this));
                this._typeAhead.bind('typeahead:asyncreceive', $.proxy(this._oncompleted, this));

                var self = this;

                this._typeAhead.keypress(function(event) {

                    if(event.which !== 13){
                        self.isTyping = true;
                        return;
                    }

                    if (event.which == 13 && (self.isTyping === false)) {
                        self._onSubmit(true);
                    }
                });

                var hotelsSource = this._getHotelsSource();
                var suggestionTemplate = function(item) {

                    var text = item.name,
                        cur = 0,
                        el = document.createElement('DIV');

                    $.each(item.highlightWidth, function (i, highlight) {

                        var pos = highlight[0],
                            width = highlight[1];

                        if (cur < pos) {
                            el.appendChild(document.createTextNode(text.substr(cur, pos - cur)));
                        }

                        el.appendChild(document.createElement('STRONG'))
                            .appendChild(document.createTextNode(text.substr(pos, width)));

                        cur = pos + width;
                    });

                    if (cur < text.length) {
                        el.appendChild(document.createTextNode(text.substr(cur, text.length - cur)));
                    }
                    if (item.country) {
                        el.appendChild(document.createTextNode(' (' + item.country + ' | ' + item.region + ')'));
                    }
                    var iconDiv = document.createElement('DIV');
                    var textDiv = el;

                    iconDiv.setAttribute('class', item.isDestination ? 'destination-icon' : 'hotel-icon');
                    el = document.createElement('DIV');
                    el.appendChild(iconDiv);
                    el.appendChild(textDiv);

                    return el.outerHTML;
                };
                var hotelsSettings = {
                    name: 'hotels',
                    display: this.option('dataField'),
                    source: hotelsSource,
                    limit: this.option('limit'),
                    templates: {
                        suggestion: suggestionTemplate,
                        notFound: function() {
                            return self._shouldShowNoSearchResults() ?
                                $('[data-fcse-role="not-found-proto"]', self.element).html() :
                                null;
                        }
                    }
                };

                var destinationsSource = this._getDestinationsSource();
                var destinationsSettings = {
                    name: 'destinations',
                    display: this.option('dataField'),
                    source: destinationsSource,
                    limit: this.option('limit'),
                    templates: {
                        suggestion: suggestionTemplate,
                        header: Handlebars.compile($('[data-fcse-role="destinations-header-proto"]', this.element).html()),
                        notFound: function() {
                            return self._shouldShowNoSearchResults() ?
                                $('[data-fcse-role="not-found-proto"]', self.element).html() :
                                null;
                        }
                    }
                };

                if (this.option('useHeader') && $('[data-fcse-role="hotels-header-proto"]', this.element).length) {
                    hotelsSettings.templates.header = Handlebars.compile($('[data-fcse-role="hotels-header-proto"]', this.element).html());
                    $('body').on('click', '.searchwidget-header-clickable', $.proxy(this._onSubmit, this, false));
                }

                this._typeAhead.typeahead({
                    minLength: this.option('minLength'),
                    hint: this.option('useHint'),
                    highlight: this.option('useHighlight')
                }, hotelsSettings, destinationsSettings);

                this.element.on('click', '[data-fcse-role="paging"]', function() {});

                /*var searchMaskHotelSearch = this._getHotelSearch('searchmask-search-widget');

                if (searchMaskHotelSearch) {
                    this._typeAhead.typeahead('val', searchMaskHotelSearch.replace(/\+/g, ' '));
                    this.setValueToUi();
                }*/

                var searchFieldMatch = window.location.search.match(/searchField=([\w\-]+)&?/);
                var searchFieldValue = null;
                if (searchFieldMatch && searchFieldMatch.length === 2) {
                    searchFieldValue = searchFieldMatch[1];
                }
                if (searchFieldValue == self.element.attr('id')) {
                    if (searchFieldValue == 'searchmask-search-widget') {
                        var hotelNameMatch = window.location.search.match(/searchValue=(.[^&]+)/);
                        if (hotelNameMatch && hotelNameMatch.length == 2) {
                            this._typeAhead.typeahead('val', decodeURIComponent(hotelNameMatch[1].replace(/\+/g, ' ')));
                        }
                    }
                    self.setValueToUi();
                }
            }
        },

        /**
         * Prepares and returns source for typeahead
         * @returns {Bloodhound}
         * @private
         */
        _getHotelsSource: function() {
            return new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace(this.option('dataField')),
                queryTokenizer: function(str) {
                    str = $.trim((_.isUndefined(str) || str === null) ? '' : str + '');
                    return str ? str.split(/\s+/) : [];
                },
                identify: $.proxy(this._identify, this),
                remote: {
                    url: 'hotels',
                    wildcard: '%QUERY',
                    transform: $.proxy(this._transformResponse, this),
                    prepare: $.proxy(this._prepareHotelsRequest, this),
                    rateLimitWait: this.option('delay')
                }
            });
        },

        /**
         * Prepares and returns source for typeahead
         * @returns {Bloodhound}
         * @private
         */
        _getDestinationsSource: function() {
            return new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace(this.option('dataField')),
                queryTokenizer: function(str) {
                    str = $.trim((_.isUndefined(str) || str === null) ? '' : str + '');
                    return str ? str.split(/\s+/) : [];
                },
                identify: $.proxy(this._identify, this),
                remote: {
                    url: 'destinations',
                    wildcard: '%QUERY',
                    transform: $.proxy(this._transformResponse, this),
                    prepare: $.proxy(this._prepareDestinationsRequest, this),
                    rateLimitWait: this.option('delay')
                }
            });
        },

        /**
         * Overrides request settings before actual ajax request
         * @param term
         * @param settings
         * @returns {*}
         * @private
         */
        _prepareHotelsRequest: function(term, settings) {
            var params = {};

            params[this.option('routeParamName')] = $.trim(term);
            params[this.option('routeTypeName')] = this.option('routeType');
            params['_locale'] = this._locale;
            params['bookingType'] = this.option('bookingType');
            params['searchField'] = this._getWidgetId();
            params = $.extend(params, this._getRootScopeParams());

            settings.url = Routing.generate(this._hotelsRoute, params);
            this._isHotelDataLoaded = false;

            return settings;
        },

        /**
         * Overrides request settings before actual ajax request
         * @param term
         * @param settings
         * @returns {*}
         * @private
         */
        _prepareDestinationsRequest: function(term, settings) {
            var params = {};

            params[this.option('routeParamName')] = $.trim(term);
            params[this.option('routeTypeName')] = this.option('routeType');
            params['_locale'] = this._locale;
            params['bookingType'] = this.option('bookingType');
            params['searchField'] = this._getWidgetId();
            params = $.extend(params, this._getRootScopeParams());

            settings.url = Routing.generate(this._destinationsRoute, params);
            this._isDestinationDataLoaded = false;

            return settings;
        },

        /**
         * Transforms received response to array of items
         * @param response
         * @returns {*}
         * @private
         */
        _transformResponse: function(response) {
            var fieldName = this.option('responseDataField');

            if (!response.meta || !response.meta[fieldName]) {
                throw Error('Field "' + fieldName + '" is mandatory for the response');
            }
            var items = response.meta[fieldName];

            $.each(items, function (i, item) {
                if (!item.highlights) {
                    item.highlights = [];
                }
                if (!item.highlightWidth) {
                    item.highlightWidth = [];
                }
            });

            if (response.meta.type == this.option('hotelResponseType')) {
                this._lastResponse = items;
                this._isHotelDataLoaded = true;
                if (this._posponedSubmit) {
                    this._onSubmit(true);
                }
            } else if (response.meta.type == this.option('destinationResponseType')) {
                this._lastDestinationsResponse = items;
                this._isDestinationDataLoaded = true;
            }
            return items;
        },

        /**
         * Returns identity for data object
         * @param item
         * @returns {*}
         * @private
         */
        _identify: function(item) {
            var identity = item[this.option('identifyField')];
            if (!identity) {
                throw Error('Object must have identity field "id"');
            }
            return identity;
        },

        _shouldShowNoSearchResults: function() {
            var isAllLoaded = this._isHotelDataLoaded && this._isDestinationDataLoaded;

            if (!isAllLoaded) {
                return false;
            }
            return !this._lastResponse.length && !this._lastDestinationsResponse.length;
        },

        /**
         * Select item handler
         * @param e
         * @param suggestion
         * @private
         */
        _onSuggestionSelect: function(e, suggestion) {
            this._currentQuery = $.trim(suggestion[this.option('dataField')]);

            var widgetId = this._getWidgetId();

            if (this.option('scoped')) {
                this.setValue({
                    'hotelName': this._currentQuery,
                    'hotelId': suggestion.hotelId
                });
            } else if (!suggestion.url) {
                // In case url is empty we use indistinct search
                this._onSubmit(true, null);
            } else {
                var query = this._getQuery(),
                    widgetContext = '';

                if (query) {
                    delete query['hotelName'];
                    delete query['hotelId'];
                    delete query['giataId'];
                }
                if (widgetId == 'search-widget') {
                    // Reset query params for header search
                    query = {};
                }
                if (suggestion.isDestination) {
                    delete query['groupNames'];
                    widgetContext = '&searchField=' + widgetId + '-destination';
                } else {
                    widgetContext = '&searchField=' + widgetId + '&searchValue=' + this._currentQuery;
                    // TODO: Consider to not apply model query to the top search
                    if (widgetId == 'search-widget') {
                        this._setHotelSearch('searchmask-search-widget', '');
                        this._setHotelSearch('search-widget', this._currentQuery);
                    } else if (widgetId == 'searchmask-search-widget') {
                        this._setHotelSearch('search-widget', '');
                        this._setHotelSearch('searchmask-search-widget', this._currentQuery);
                    }
                }
                var additionalParams = $.param(query);

                additionalParams += widgetContext;

                window.location.href = suggestion.url + (additionalParams ? '&' + additionalParams : '');
            }
        },

        /**
         * Submits the current search value
         * @param force
         * @param event
         * @private
         */
        _onSubmit: function(force, event) {
            var value = $.trim(this._typeAhead.typeahead('val'));
            this._posponedSubmit = false;

            if (!value && !this._lastResponse) {
                return;
            }
            if (value && !this._isHotelDataLoaded) {
                // If user hit enter before hotels loaded we wait for result and reproduce it
                this._posponedSubmit = true;
                return;
            }

            if (value && this._lastResponse && this._lastResponse.length === 1) {
                this._onSuggestionSelect({}, this._lastResponse[0]);
                return;
            }
            if (!value && this._getWidgetId() == 'search-widget') {
                return;
            }

            if (this._lastDestinationsResponse && this._lastDestinationsResponse.length === 1) {
                const item = this._lastDestinationsResponse[0];
                this._onSuggestionSelect({}, item);
                return false;
            }

            if (this._lastDestinationsResponse && this._lastDestinationsResponse.length > 1) {
                let matchedItem;
                const expr = new RegExp(".*?" + value + "(\W|$)" , 'gi');
                $.each(this._lastDestinationsResponse, function (i, item) {
                    if (item.name.match(expr)) {
                        matchedItem = item;
                        return false;
                    }
                });

                if (matchedItem) {
                    this._onSuggestionSelect({}, matchedItem);
                    return false;
                }
            }

            if (force || (this._redirectTarget && this._typeAhead.parent().children('.tt-menu').hasClass('tt-open') == true)) {
                var widgetId = (typeof this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') !== 'undefined') ?
                    this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') : '';
                var rootScopeQuery = {
                    'hotelName': value,
                    'searchField': widgetId
                };

                if (widgetId == 'searchmask-search-widget') {
                    rootScopeQuery = $.extend({}, this._getQuery(), rootScopeQuery);
                    this._setHotelSearch('searchmask-search-widget', value);
                    this._setHotelSearch('search-widget', '');
                } else if (widgetId == 'search-widget') {
                    this._setHotelSearch('searchmask-search-widget', '');
                    this._setHotelSearch('search-widget', value);
                }
                // Deleting hotelId and giataId if we use not concrete search
                // TODO: Need to refactor processing both hotelId and hotelName logic
                delete rootScopeQuery['hotelId'];
                delete rootScopeQuery['giataId'];

                window.location.href = this._redirectTarget + '?' + $.param(rootScopeQuery) + '&searchValue=' + value;
            }
            this._typeAhead.typeahead('close');
        },

        /**
         * Returns query
         * @returns {Object}
         * @private
         */
        _getQuery: function() {
            return this._options.rootScope ? this._options.rootScope.getQuery() :  {};
        },

        /**
         * Returns matches root scope params
         * @returns {{}}
         * @private
         */
        _getRootScopeParams: function() {
            var result = {},
                rootScopeParams;

            if (this.option('rootScope') && this.option('useRootScopeParams').length) {
                rootScopeParams = this.option('rootScope').getParams();

                _.each(this.option('useRootScopeParams'), function(name) {
                    _.each(rootScopeParams, function(paramValue, paramName) {
                        if (paramName.indexOf(name) === 0) {
                            result[paramName] = _.isArray(paramValue) ? paramValue.join(';') : paramValue;
                        }
                    });
                });
            }
            return result;
        },

        /**
         * @protected
         * @returns {void}
         */
        setValueToUi: function () {
            var value = this.getValue();
            if (this._typeAhead && this._typeAhead.typeahead('val') !== value.name) {
                this._typeAhead.typeahead('val', value.name);
                this._currentQuery = value.name;
            }
        },

        /**
         * Returns the current hotel name search query
         * @protected
         * @returns {String} The hotel name search query
         */
        getValueFromUi: function () {
            return this._currentQuery;
        },

        /**
         * Returns current value
         * @returns {null|*}
         */
        getValue: function() {
            var result = this._typeAhead ? this._typeAhead.typeahead('val') : '';
            // TODO: Need to refactor processing both hotelId and hotelName logic
            if (!result) {
                var value = Widget.prototype.getValue.apply(this, []);
                value = value ? value.name : null;
            }
            return {
                'hotelName': result || value,
                'hotelId': this._getQuery()['hotelId'] || this._getQuery()['giataId'] || ''
            };
        },

        /**
         * @protected
         */
        _updateDisplay: function() {
        },

        /**
         * Return widget id
         * @returns {*}
         * @private
         */
        _getWidgetId: function() {
            if (!this._typeAhead) {
                return null;
            }

            return (typeof this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') !== 'undefined') ?
                this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') : '';
        },

        /**
         *
         * @param widgetId
         * @param searchValue
         * @private
         */
        _setHotelSearch: function(widgetId, searchValue) {
            searchValue = searchValue ? $.trim(searchValue) : null;

            if (searchValue) {
                $.cookie('hotelSearch-' + widgetId, encodeURIComponent(searchValue), {
                    path    : '/',
                    secure  : false
                });
            } else {
                $.cookie('hotelSearch-' + widgetId, '', {
                    path    : '/',
                    secure  : false
                });
            }
        },

        /**
         *
         * @param widgetId
         * @returns {*}
         * @private
         */
        _getHotelSearch: function(widgetId) {
            var value = $.cookie('hotelSearch' + widgetId);

            if (value) {
                return decodeURIComponent(value);
            }
            return null;
        }
    });

    return SearchWidget;
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/search/searchWidget.js